<template>
  <div class="container">
    <BaseFrame
    >
      <div slot="content">
        <lk-form
          :model="customerInfo"
          label-position="right"
          :label-width="130"
          ref="recallForm.saleRecallPlan"
        >
          <div class="cardContainer">
            <lk-card title="基本信息">
              <lk-row :gutter="16">
                <lk-col span="7" v-for="(item, index) in baseList" :key="index">
                  <lk-form-item :label="item.name">
                    <span>{{customerInfo[item.value] || ''}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="收货信息">
              <lk-row :gutter="16">
                <lk-col span="7" v-for="(item, index) in consigneeList" :key="index">
                  <lk-form-item :label="item.name">
                    <span>{{customerInfo.addressInfo[item.value] || ''}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="发票信息">
              <lk-row :gutter="16">
                <lk-col span="7" v-for="(item, index) in billList" :key="index">
                  <lk-form-item :label="item.name">
                    <span>{{customerInfo.invoicesInfo[item.value] || ''}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="证件信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <div v-for="(item, index) in customerInfo.imgList" :key="index" class="mb8">
                    <Uploader style="width:250px" :able='false' v-model="item.url"></Uploader>
                  </div>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
  </div>
</template>

<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import toolsService from '../../../services/lgq/services';
import utils from '../../../libs/utils';
import SupplierListSelect from '../../../components/SupplierListSelect.vue';
import Uploader from '../../../components/Uploader.vue';

export default {
  name: 'customerInfo',
  components: {
    BaseFrame,
    SupplierListSelect,
    Uploader,
  },
  data() {
    return {
      customerInfo: {
        addressInfo: {},
        invoicesInfo: {},
      },
      baseList: [
        { name: '账户id：', value: 'id' },
        { name: '创建时间：', value: 'createTime' },
        { name: '最后修改人：', value: 'modifiedUserName' },
        { name: '最后修改时间：', value: 'modifiedTime' },
        { name: '姓名：', value: 'name' },
        { name: '手机号：', value: 'mobile' },
        { name: '公司名称：', value: 'companyName' },
      ],
      consigneeList: [
        { name: '联系人：', value: 'consigneeName' },
        { name: '联系电话：', value: 'consigneePhone' },
        { name: '收货地址：', value: 'address' },
      ],
      billList: [
        { name: '公司名称：', value: 'companyName' },
        { name: '纳税人识别码：', value: 'dutyParagraph' },
        { name: '企业地址：', value: 'companyAddress' },
        { name: '企业电话：', value: 'phone' },
        { name: '开户行：', value: 'bank' },
        { name: '开户行银行卡号：', value: 'bankAccount' },
      ],
    };
  },
  computed: {
    selectedIds() {
      const result = [];
      this.tableData.forEach((item) => {
        result.push(item.itemId);
      });
      return result;
    },
  },
  methods: {
    getInfo(id) {
      toolsService.customerInfo({ customerId: id }).then((res) => {
        if (res.data.status === 200) {
          this.customerInfo = res.data.data;
          this.resetData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    resetData() {
      if (this.customerInfo.customerAddresses && this.customerInfo.customerAddresses.length > 0) {
        this.customerInfo.addressInfo = this.customerInfo.customerAddresses[0];
        const {
          provinceName, cityName, district, address,
        } = this.customerInfo.addressInfo;
        this.customerInfo.addressInfo.address = `${provinceName} ${cityName} ${district} ${address}`;
        const { createTime, modifiedTime } = this.customerInfo;
        this.customerInfo.createTime = utils.formatDateToSecond(createTime);
        this.customerInfo.modifiedTime = utils.formatDateToSecond(modifiedTime);
      } else {
        this.customerInfo.addressInfo = {};
      }
      if (this.customerInfo.customerInvoices && this.customerInfo.customerInvoices.length > 0) {
        this.customerInfo.invoicesInfo = this.customerInfo.customerInvoices[0];
      } else {
        this.customerInfo.invoicesInfo = {};
      }
      if (this.customerInfo.picUrls && this.customerInfo.picUrls.length > 0) {
        this.customerInfo.imgList = this.customerInfo.picUrls.map(item => ({
          url: item,
        }));
      }
    },
  },
  created() {
    this.getInfo(this.$route.params.id);
  },
};
</script>

<style scoped lang="less">
 .content {
    padding: 16px 0px 16px 0px;
    padding-bottom: 0px;
  }
</style>
